import React, { useEffect, useRef } from 'react';
import { IoIosClose } from 'react-icons/io';
import ReactDrawer from 'react-modern-drawer';
import { oneOf, bool, string, node, func } from 'prop-types';
import 'react-modern-drawer/dist/index.css';
import './styles.css';
import { FiArrowLeftCircle, FiArrowRightCircle } from 'react-icons/fi';

const Drawer = ({
  // Whether the drawer shows at all
  isDrawerOpen = false,
  onClose = () => {},
  // Whether the drawer can be collapsed, but still open (with a small icon on the right to expand again)
  isCollapsible = false,
  // Whether the drawer is collapsed
  isCollapsed = false,
  setIsCollapsed = () => {},
  // Whether to show a scrollbar when the drawer is open
  isScrollable = true,
  title = '',
  subTitle = '',
  direction = 'right',
  // Styles
  reactDrawerId = 'modern-drawer',
  drawerContainerClassName = '',
  reactDrawerClassName = '',
  // Whether certain modals are open
  isConfirmModalOpen,
  previewUnCat = false,
  isConfirmPreviewModal = false,
  selectorsToNotCloseOn = [],
  // Drawer contents
  children,
}) => {
  let menu = useRef();

  useEffect(() => {
    let handler = (e) => {
      const isBothModalsClosed =
        !isConfirmModalOpen && !previewUnCat && !isConfirmPreviewModal;

      const isClickedInsideIgnoredClass = selectorsToNotCloseOn.some(
        (selector) => e.target.closest(selector)
      );

      if (
        menu.current &&
        !menu.current.contains(e.target) &&
        isBothModalsClosed &&
        !isClickedInsideIgnoredClass
      ) {
        if (isCollapsible) {
          setIsCollapsed(true);
        } else {
          onClose();
        }
      }
    };
    document.addEventListener('mousedown', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
    };
  }, [
    isConfirmModalOpen,
    isConfirmPreviewModal,
    previewUnCat,
    onClose,
    isCollapsible,
    setIsCollapsed,
  ]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={drawerContainerClassName}>
      <ReactDrawer
        className={`${reactDrawerClassName} drawer-container ${isCollapsed ? 'collapsed' : ''}`}
        id={reactDrawerId}
        enableOverlay={!isCollapsed}
        open={isDrawerOpen}
        direction={direction}
      >
        <div
          className={`drawer-refWrapper ${isScrollable && !isCollapsed ? 'scrollable' : ''}`}
          ref={menu}
        >
          <div className="drawer-title-wrap">
            <div
              style={{
                marginRight: '50px',
              }}
            >
              {typeof title === 'string' ? (
                <h4 className="drawer-title">{title}</h4>
              ) : (
                <div className="drawer-title">{title}</div>
              )}
              {subTitle ? (
                <div className="drawer-subtitle">{subTitle}</div>
              ) : null}
            </div>
            {!isCollapsed && (
              <div className="drawer-close">
                <IoIosClose onClick={onClose} style={{ fontSize: '30px' }} />
              </div>
            )}
          </div>
          {isCollapsible && (
            <div
              className={
                isCollapsed ? 'closemenu-collapse' : 'closemenu-drawer-icon'
              }
              onClick={toggleCollapse}
            >
              {isCollapsed ? (
                <FiArrowLeftCircle className="fsdkm" />
              ) : (
                <FiArrowRightCircle className="fsdkm" />
              )}
            </div>
          )}
          {children}
        </div>
      </ReactDrawer>
    </div>
  );
};

Drawer.propTypes = {
  isCollapsible: bool,
  isCollapsed: bool,
  setIsCollapsed: func,
  isDrawerOpen: bool.isRequired,
  onClose: func.isRequired,
  isScrollable: bool,
  id: string,
  direction: oneOf(['left', 'right', 'top', 'bottom']),
  children: node,
  title: node,
  subTitle: node,
  previewUnCat: bool,
  reactDrawerId: string,
  drawerContainerClassName: string,
  reactDrawerClassName: string,
  isConfirmModalOpen: bool,
  isConfirmPreviewModal: bool,
};

export default Drawer;
